<template>
  <v-card class="auth-content elevation-12 pa-8" max-width="612">
    <v-card-text>
      <div class="text-h5-nk">{{ $t('loginForm.title') }}</div>
      <v-form @keyup.enter.native="handleLogin" class="mt-5">
        <v-text-field ref="email" :errorMessages="emailErrors"
                      outlined
                      dense
                      :disabled="progress" v-model="email"
                      name="login" :placeholder="$t('loginForm.fields.email.label')" type="text"
                      autocomplete="username">
          <template slot="prepend-inner">
            <v-icon>$vuetify.icons.person</v-icon>
          </template>
        </v-text-field>

        <v-text-field ref="password" :errorMessages="passwordErrors"
                      outlined
                      dense
                      :disabled="progress" v-model="password"
                      name="password" :placeholder="$t('loginForm.fields.password.label')" id="password"
                      type="password" autocomplete="current-password">
          <template slot="prepend-inner">
            <v-icon>$vuetify.icons.key</v-icon>
          </template>
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="light-blue-nk n700" class="white--text" :loading="progress" @click="handleLoginButtonClick"
             :disabled="progress">{{ $t('loginForm.buttons.login.title') }}
      </v-btn>
      <v-spacer></v-spacer>

      <div class="text-button-nk text-subtitle-1" @click="handleClickForgotPasswordButton">
        {{ $t('loginForm.fields.forgotPassword.label') }}
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>

import api from '../api'
import _ from 'lodash'
import {extractUserErrorMessage, extractValidationErrors} from 'js-core/helpers/api'
import {getMainAppURL} from '../helpers/baseurl'

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      email: null,
      password: null,
      progress: false,
      validationErrors: {},
    }
  },
  computed: {
    emailErrors() {
      return _.get(this.validationErrors, 'email', null)
    },
    passwordErrors() {
      return _.get(this.validationErrors, 'password', null)
    }
  },
  methods: {
    async handleLoginButtonClick() {
      await this.handleLogin()
    },
    async handleLogin() {
      this.validationErrors = {}

      this.progress = true
      try {
        await api.login(this.email, this.password, this.$i18n.locale)
        window.location = getMainAppURL()
      } catch (e) {
        this.validationErrors = extractValidationErrors(e)

        if (this.validationErrors === null) {
          this.$snotify.error(extractUserErrorMessage(e, this.$i18n.t("loginForm.errors.unableLogin")))
        }
      }
      this.progress = false
    },
    handleClickForgotPasswordButton() {
      this.$router.push('/account-recovery')
    }
  }
}
</script>

<style>
.locale-changer .v-input__control {
  min-height: 40px !important;
}

.absolute {
  position: absolute;
}


</style>